<template>
  <div class="dash-chart" :style="{ height: height + 'px' }">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

// A thin wrapper so the dashboard can declare a chart as { type, data, options }.
// The chart is rebuilt whenever `data` changes, and destroyed with the component.
export default {
  name: "DashChart",
  props: {
    type: { type: String, required: true },
    data: { type: Object, required: true },
    options: { type: Object, default: () => ({}) },
    plugins: { type: Array, default: () => [] },
    height: { type: Number, default: 300 },
  },
  data() {
    return { chart: null };
  },
  watch: {
    data: { deep: true, handler() { this.draw(); } },
  },
  mounted() {
    this.draw();
  },
  beforeDestroy() {
    if (this.chart) this.chart.destroy();
  },
  methods: {
    draw() {
      if (this.chart) this.chart.destroy();
      this.chart = new Chart(this.$refs.canvas, {
        type: this.type,
        data: this.data,
        plugins: this.plugins,
        options: { responsive: true, maintainAspectRatio: false, ...this.options },
      });
    },
  },
};
</script>

<style scoped>
.dash-chart {
  position: relative;
  width: 100%;
}
</style>
